export enum EAppType {
  Orga = 1,
  Tech = 2,
  Team = 3,
  Link = 4,
}
